export const TRANSACTIONS_TABLE_TITLE = 'Transactions';
export const TRANSACTIONS_TABLE_INFO_URL = '';
